import { AccordionUIProps } from '@app/interfaces/userInterface';
import React from 'react';

const AccordionUI: React.FC<AccordionUIProps> = (props) => {
  return <div>{props.children}</div>;
};

export default AccordionUI;
